/*
 * @title App
 * @description Application entry point
 */
import Menu from "./components/menu";
import Slider from "./components/slider";
import Toggle from "./components/toggle";
import Form from './components/form';
import ELVideo from './components/video';

document.addEventListener("DOMContentLoaded", function () {
  Menu();
  Slider();
  Toggle();
  Form(); 
  ELVideo();
});

import "./components/fnJQuery";
